export { InfoPage as default } from '@/components/pages/Ir/Stock/Info'
